import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const verifyOTP = createAsyncThunk("verifyOTP", async (values) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/user/otp-verify`;

  const email = localStorage.getItem("user-email");

  return toast.promise(
    new Promise(async (resolve, reject) => {
      try {
        let finalObj = {
          otp: values.otp.toString().padStart(6, 0),
          email: email,
        };
        let response = await axios.patch(url, finalObj, { withCredentials: true });
        if (response.data.status === "success") {
          const token = response.data.token;
          localStorage.setItem("cu_user", token);
          resolve(response);
          return response?.data;
        } else {
          reject(response?.data?.message);
        }
      } catch (error) {
        reject(error?.response?.data);
      }
    }),
    {
      pending: "Verifying...",
      success: "Email verified successfully",
      error: {
        render({ data }) {
          return `${data?.status}`;
        },
      },
    }
  );
});

export const getUserDetails = createAsyncThunk("getUserDetails", async (id) => {
  try {
    const token = localStorage.getItem("cu_user");
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/user/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    ;
    return data;
  } catch (error) {
    console.error(error);
    return error
  }
});

// export const logout = createAsyncThunk("logout", () => {
//   return localStorage.removeItem("cu_user");
// });

export const SignOut = createAsyncThunk("SignOut", async (values) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/user/signOut`;

  const token = localStorage.getItem("cu_user");

  return toast.promise(
    new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(
          url,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.status === "success") {
          localStorage.removeItem("cu_user");
          resolve(response);
          return response?.data;
        } else {
          reject(response?.data?.message);
        }
      } catch (error) {
        reject(error?.response?.data);
      }
    }),
    {
      pending: "Signing out...",
      success: "Sign out successfully",
      error: {
        render({ data }) {
          return `${data?.status}`;
        },
      },
    }
  );
});

export const SignOutAll = createAsyncThunk("SignOutAll", async (values) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/user/signOutAll`;

  const token = localStorage.getItem("cu_user");

  return toast.promise(
    new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(
          url,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.status === "success") {
          localStorage.removeItem("cu_user");
          resolve(response);
          return response?.data;
        } else {
          reject(response?.data?.message);
        }
      } catch (error) {
        reject(error?.response?.data);
      }
    }),
    {
      pending: "Signing out...",
      success: "Sign out successfully",
      error: {
        render({ data }) {
          return `${data?.status}`;
        },
      },
    }
  );
});

const user = localStorage.getItem("cu_user");

export const AuthSlice = createSlice({
  name: "auth",

  initialState: {
    isLoggedIn: user ? true : false,
    status: user ? "Logged In" : "Not logged in",
    user: user ? user : [],
    userData: [],
    errors: [],
  },
  reducers: {
    updateUser: (state, action) => {
      state.user = action.payload;
    }
  },
  extraReducers: {
    [verifyOTP.pending]: (state) => {
      ;
      state.status = "Not logged in";
      state.user = null;
    },
    [verifyOTP.fulfilled]: (state, action) => {
      ;
      state.status = "success";
      state.isLoggedIn = true;
      state.user = action.payload.data.token;
    },
    [verifyOTP.rejected]: (state, action) => {
      ;
      state.status = "Login Failed";
      state.isLoggedIn = false;
      state.user = null;
      state.userData = null;
    },
    [getUserDetails.pending]: (state) => {
      ;
      state.userData = null;
    },
    [getUserDetails.fulfilled]: (state, action) => {
      ;
      state.status = "success";
      state.userData = action?.payload?.data;
      state.error = action.error;
    },
    [getUserDetails.rejected]: (state, action) => {
      ;
      state.status = "Failed";
      state.userData = null;
      state.error = action.error;
    },
    [SignOut.pending]: (state, action) => {
      ;
      state.status = "pending";
    },
    [SignOut.fulfilled]: (state, action) => {
      ;
      state.status = "Log out";
      state.isLoggedIn = false;
      state.user = null;
    },
    [SignOut.rejected]: (state, action) => {
      ;
      state.status = "Failed";
      state.error = action.error;
    },
    [SignOutAll.pending]: (state, action) => {
      ;
      state.status = "pending";
    },
    [SignOutAll.fulfilled]: (state, action) => {
      ;
      state.status = "Log out";
      state.isLoggedIn = false;
      state.user = null;
    },
    [SignOutAll.rejected]: (state, action) => {
      ;
      state.status = "Failed";
      state.error = action.error;
    },
  },
});

export const { updateUser } = AuthSlice.actions;

export default AuthSlice.reducer;
